import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { formatMoney } from "../../../../utils/helpers";

export const SalaryGroupColumns = () => [
    {
        id: "teacher_name",
        label: "Teacher",
        render: (value, row) => (
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {row.teacher_name || "—"}
            </Typography>
        ),
    },
    {
        id: "period_month",
        label: "Period",
        render: (value, row) => (
            <Box sx={{ textAlign: "center" }}>
                <Chip size="small" variant="outlined" label={row.period_month || "—"} />
            </Box>
        ),
    },
    {
        id: "lessons_count",
        label: "Lessons",
        render: (value, row) => (
            <Typography variant="body2" sx={{ textAlign: "center" }}>
                {row.lessons_count ?? 0}
            </Typography>
        ),
    },
    {
        id: "total_minutes",
        label: "Hours",
        render: (value, row) => {
            const minutes = Number(row.total_minutes || 0);
            const hours = minutes / 60;
            return (
                <Typography variant="body2" sx={{ textAlign: "center" }}>
                    {hours.toFixed(1)}
                </Typography>
            );
        },
    },
    {
        id: "total_amount",
        label: "Total Amount",
        render: (value, row) => (
            <Box sx={{ textAlign: "center" }}>
                <Chip
                    size="small"
                    color="error"
                    variant="outlined"
                    label={formatMoney(Number(row.total_amount || 0))}
                />
            </Box>
        ),
    },
];
